import { lazy } from 'react';

const InputPassword = lazy(() => import('./InputPassword'));

export { InputPassword };
